import { Brain, Target, Award, TrendingUp, Eye, Zap, BarChart2, AlertTriangle, MessageSquare, FlaskConical, Cpu, Trophy, Activity } from 'lucide-react';
import TabHub from '@/components/shared/TabHub';
import StrategyDashboard from '@/components/analytics/StrategyDashboard';
import OpportunityReport from '@/components/signals/OpportunityReport';
import AIPredictions from '@/components/signals/AIPredictions';
import AIPatternRecognition from '@/components/signals/AIPatternRecognition';
import AITradeSignals from '@/components/signals/AITradeSignals';
import SentimentAnalysis from '@/components/signals/SentimentAnalysis';
import Econ360Dashboard from '@/components/signals/Econ360Dashboard';
import AnomalyDetection from '@/components/signals/AnomalyDetection';
import LLMChatInterface from '@/components/chat/LLMChatInterface';
import AITradingLab from '@/components/signals/AITradingLab';
import AIModelTrainingDashboard from '@/components/ml/AIModelTrainingDashboard';
import WalkForwardValidation from '@/components/signals/WalkForwardValidation';
import MLTestDataDownload from '@/components/data/MLTestDataDownload';

export default function AIIntelligenceHub() {
  return (
    <TabHub
      title="AI Intelligence"
      subtitle="AI-powered trading signals, predictions, ML operations, and analysis across all 9 asset classes"
      icon={Brain}
      accentColor="#a855f7"
      defaultTab="macro360"
      tabs={[
        { id: 'macro360', label: 'Macro 360', icon: Activity, badge: 'FRED', component: <Econ360Dashboard /> },
        { id: 'strategies', label: 'Strategies', icon: Target, badge: 'LIVE', component: <StrategyDashboard /> },
        { id: 'opportunities', label: 'Opportunities', icon: Award, component: <OpportunityReport theme="dark" /> },
        { id: 'predictions', label: 'Predictions', icon: TrendingUp, component: <AIPredictions symbol="BTCUSD" timeframe="daily" /> },
        { id: 'patterns', label: 'Patterns', icon: Eye, component: <AIPatternRecognition symbol="BTCUSD" timeframe="daily" /> },
        { id: 'signals', label: 'Signals', icon: Zap, component: <AITradeSignals symbol="BTCUSD" timeframe="daily" /> },
        { id: 'sentiment', label: 'Sentiment', icon: BarChart2, component: <SentimentAnalysis symbol="BTCUSD" theme="dark" /> },
        { id: 'anomalies', label: 'Anomalies', icon: AlertTriangle, component: <AnomalyDetection theme="dark" /> },
        { id: 'training', label: 'Model Training', icon: Cpu, component: <AIModelTrainingDashboard /> },
        { id: 'walk-forward', label: 'Walk-Forward', icon: Trophy, component: <WalkForwardValidation theme="dark" /> },
        { id: 'test-data', label: 'Test Data', icon: FlaskConical, component: <MLTestDataDownload theme="dark" /> },
        { id: 'chat', label: 'AI Chat', icon: MessageSquare, component: <LLMChatInterface theme="dark" /> },
        { id: 'lab', label: 'Lab', icon: FlaskConical, badge: 'TEST', component: <AITradingLab /> },
      ]}
    />
  );
}
